const PromoStatusEnum = {
  Upcoming: "upcoming",
  Ongoing: "ongoing",
  Ended: "ended",
  Canceled: "cancelled",
};

export default PromoStatusEnum;
